module.exports = __webpack_public_path__ + "img/raddau.25adaa2e.jpg";